/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Audio_TInputs */

const en_tut_audio_t = /** @type {(inputs: Tut_Audio_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nearby audio and nearby chat`)
};

const id_tut_audio_t = /** @type {(inputs: Tut_Audio_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio sekitar dan chat sekitar`)
};

/**
* | output |
* | --- |
* | "Nearby audio and nearby chat" |
*
* @param {Tut_Audio_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_audio_t = /** @type {((inputs?: Tut_Audio_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Audio_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_audio_t(inputs)
	return en_tut_audio_t(inputs)
});